import { Component, OnInit } from '@angular/core';
import { Message, SelectItem } from 'primeng/primeng';
import { FlashProduct } from '../../../../models/inModels/Flash';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashService } from '../../../../services/flash/flash.service';
import { StorageService } from '../../../../services/system/storage.service';

@Component({
  selector: 'app-flash-product-edit',
  templateUrl: './flash-product-edit.component.html'
})
export class FlashProductEditComponent implements OnInit {
  id;
	model: FlashProduct;
	loading = false;
  groups: SelectItem[];
  selectedGroup: SelectItem;
	error: Message[];
	uploading = false;
	books;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private service: FlashService,
		public storageService: StorageService,
  ) { 
    this.id = this.route.snapshot.paramMap.get('productCode');
  }

  ngOnInit() {
    this.getProduct();
  }

  getProduct() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new FlashProduct(result);
        this.service.getGroupsDropdown(event).then(
          x => {
            this.groups = x;
            this.loading = false;
            this.selectedGroup = x.find(item => item.value == result.ProductGroupId.toString());
          },
          error => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          });
		},
		error => {
			this.loading = false;
			this.error = [];
			this.error.push({ severity: 'error', summary: 'Error', detail: error });
		});
	}

  goBack(): void {
		this.router.navigate(['/flash/groups']);
  }
  
  
	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new FlashProduct(result);
        this.selectedGroup = { value: result.ProductGroupId, label: result.Name };
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  
  handleImage(event): void {
	var result = this.storageService.handleSuccess(event);
	this.model.productImageId = result.PublicId;
	this.loading = false;
	}
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
	}

  initCroupDropDown(event) {
    this.loading = true;
		this.service.getGroupsDropdown(event).then(
			x => {
				this.groups = x;
        this.loading = false;
			},
			error => {
        this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  setCategory(): void {
		this.model.productGroupId = Number(this.selectedGroup.value);
	}


}



// WEBPACK FOOTER //
// ./src/app/components/flash/products/product-edit/flash-product-edit.component.ts